import { cn, Divider, Text } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import type { FC } from "react";

import { usePrompts } from "../hooks/usePrompts";

import { AssistantModeEnum } from "types";

export const ChatPanelInitialisation: FC<{
  onSend: (text: string, mode: AssistantModeEnum) => void;
  selectedMode: AssistantModeEnum;
}> = ({ onSend, selectedMode }) => {
  const { t } = useI18n();
  const { suggestedQuestions, reports, hasReports } = usePrompts();

  const items = [
    {
      title: t("apps.admin.chatAI.ui.askQuestionsTitle"),
      options: suggestedQuestions,
    },
    ...(hasReports
      ? [
          {
            title: t("apps.admin.chatAI.ui.reportTemplatesTitle"),
            options: reports,
          },
        ]
      : []),
  ];

  return (
    <div className="p-4 space-y-6">
      {items.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          {sectionIndex > 0 && (
            <div className="-mx-4 mb-6">
              <Divider />
            </div>
          )}
          <Text size="sm" weight="medium" className="text-neutral-500 mb-2">
            {section.title}
          </Text>
          <div className="space-y-2">
            {section.options.map((option, index) => {
              const Icon = option.icon;
              return (
                <button
                  key={index}
                  onClick={() => onSend(option.prompt, selectedMode)}
                  className={cn(
                    "flex items-center gap-3",
                    "w-full p-4",
                    "text-sm text-start text-neutral-500",
                    "bg-white border border-neutral-500/10 rounded-xl",
                    "shadow-sm hover:shadow-md",
                    "transition",
                    "focus:outline-primary-500",
                  )}
                >
                  <div className="flex-shrink-0 w-8 h-8 rounded-md flex items-center justify-center bg-neutral-500/10">
                    <Icon size={14} />
                  </div>
                  <Text size="sm">{option.prompt}</Text>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
